import { useCallback, useEffect, useRef, useState } from "react";
import { dedupedGet } from "@/lib/api";
import { SEEN_EVENT } from "@/lib/seen";

const EMPTY = { avi: { count: 0, items: [] }, tasks: { count: 0, waiting: [], to_verify: [] } };
export const DEFAULT_ORDER = ["dashboard", "tasks", "documents", "avi", "crm", "tresorerie", "pointage"];

/** iter395 — pastilles (calcul serveur `/badges`) + ordre des modules (`/sidebar/order`) : montage, retour sur la fenêtre, toutes les 30 s. */
export function useSidebarData(userId) {
  const [badges, setBadges] = useState(EMPTY);
  const [order, setOrder] = useState(DEFAULT_ORDER);
  const stopRef = useRef(false);
  const refresh = useCallback(async () => {
    const [b, o] = await Promise.allSettled([dedupedGet("/badges"), dedupedGet("/sidebar/order")]);
    if (stopRef.current) return;
    if (b.status === "fulfilled") setBadges(b.value.data || EMPTY);
    if (o.status === "fulfilled" && Array.isArray(o.value.data?.order)) setOrder(o.value.data.order);
  }, []);
  useEffect(() => {
    if (!userId) return undefined;
    stopRef.current = false;
    refresh();
    const id = setInterval(refresh, 30000);
    const onVisible = () => { if (document.visibilityState === "visible") refresh(); };
    const onSeen = (e) => {
      const { module, id: itemId } = e.detail || {};
      setBadges((prev) => {
        if (module === "avi") { const items = prev.avi.items.filter((x) => x.id !== itemId); return { ...prev, avi: { count: Math.max(0, prev.avi.count - (prev.avi.items.length - items.length)), items } }; }
        if (module === "tasks") { const w = prev.tasks.waiting.filter((x) => x.id !== itemId); const v = prev.tasks.to_verify.filter((x) => x.id !== itemId); return { ...prev, tasks: { count: w.length + v.length, waiting: w, to_verify: v } }; }
        return prev;
      });
    };
    window.addEventListener("focus", refresh);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener(SEEN_EVENT, onSeen);
    window.addEventListener("avi:refresh-summary", refresh);
    window.addEventListener("desk:sidebar-order", refresh);
    return () => {
      stopRef.current = true; clearInterval(id);
      window.removeEventListener("focus", refresh);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener(SEEN_EVENT, onSeen);
      window.removeEventListener("avi:refresh-summary", refresh);
      window.removeEventListener("desk:sidebar-order", refresh);
    };
  }, [userId, refresh]);
  return { badges, order, setOrder, refresh };
}
